export enum InvoiceStatusEnum {
  All = 0, // Alla
  Paid = 1, // Betald
  UnPaid = 2, // Obetald
  PartlyPaid = 3, // Delbetald
  Overdue = 4, // Förfallen
  Canceled = 5, // Makulerad
}
